import React, { useRef } from "react";
import { Label, Input, Button } from "reactstrap";
import { connect } from "react-redux";

//components
import { debounce } from "../../common/commonFiles/debounce";
import Loader from "../../common/Components/Loader/Loader";
import notifications from "../../common/Components/Notifications/Notification";
// actions
import {
    createCatAlogue,
    updateCatAlogue,
} from "../../Store/catelogue/actions";
import { trackCatalogueCreated } from "../../utils/cataloguePublicAnalytics";
export const AddOrEditCatalogue = (props: any) => {
    const [loading, setLoading]: any = React.useState(false);
    const submitInFlight = useRef(false);
    const [form, setForm]: any = React.useState(
        props.editData?._id
            ? {
                name: props.editData?.name,
                description: props?.editData?.description,
                category: props.editData?.category || "",
                targetMarket: props.editData?.targetMarket || "",
            }
            : {
                name: "",
                description: "",
                category: "",
                targetMarket: "",
            }
    );
    const [Error, setError]: any = React.useState({
        name: "",
        description: "",
        category: "",
        targetMarket: ""
    });
    let error = "";
    const validate = () => {
        let err = Error;
        error = "";

        // Name validation
        if (form?.name === "" || !form?.name?.trim()) {
            error = "Required";
            err = {
                ...err,
                name: "Catalogue name is required!",
            };
        } else if (form?.name?.length < 3) {
            error = "Required";
            err = {
                ...err,
                name: "Catalogue name must be at least 3 characters long!",
            };
        } else if (form?.name?.length > 100) {
            error = "Required";
            err = {
                ...err,
                name: "Catalogue name must not exceed 100 characters!",
            };
        } else {
            err = {
                ...err,
                name: "",
            };
        }

        // Description validation
        if (form?.description === "" || !form?.description?.trim()) {
            error = "Required";
            err = {
                ...err,
                description: "Description is required!",
            };
        } else if (form?.description?.length > 500) {
            error = "Required";
            err = {
                ...err,
                description: "Description must not exceed 500 characters!",
            };
        } else {
            err = {
                ...err,
                description: "",
            };
        }

        // Category validation (optional field)
        if (form?.category && form?.category?.length > 100) {
            error = "Required";
            err = {
                ...err,
                category: "Category must not exceed 100 characters!",
            };
        } else {
            err = {
                ...err,
                category: "",
            };
        }

        // Target Market validation (optional field)
        if (form?.targetMarket && form?.targetMarket?.length > 200) {
            error = "Required";
            err = {
                ...err,
                targetMarket: "Target Market must not exceed 200 characters!",
            };
        } else {
            err = {
                ...err,
                targetMarket: "",
            };
        }

        setError(err);
        return error;
    };

    const handleSubmit = () => {
        if (submitInFlight.current) return;
        let result: any = validate();
        if (result?.length === 0) {
            submitInFlight.current = true;
            setLoading(true);
            props?.editData?._id
                ? props.updateCatAlogue(
                    {
                        catalougeId: props?.editData?._id,
                        name: form?.name?.trim(),
                        description: form?.description?.trim(),
                        category: form?.category?.trim() || "",
                        targetMarket: form?.targetMarket?.trim() || ""
                    },
                    (res: any) => {
                        submitInFlight.current = false;
                        setLoading(false);
                        if (res?.success) {
                            notifications({
                                title: "Success!",
                                message: "Catalogue updated.",
                                type: "success",
                            });
                            props.closeModal();
                            props.getAllData();
                        } else {
                            notifications({
                                title: "Error!",
                                message: "Could not update this catalogue. Your changes are still here; please try again.",
                                type: "danger",
                            });
                        }
                    }
                )
                : props.createCatAlogue(
                    {
                        name: form?.name?.trim(),
                        description: form?.description?.trim(),
                        category: form?.category?.trim() || "",
                        targetMarket: form?.targetMarket?.trim() || "",
                        createdAt: new Date().toISOString()
                    },
                    (res: any) => {
                        submitInFlight.current = false;
                        setLoading(false);
                        if (res?.success) {
                            notifications({
                                title: "Success!",
                                message: "Catalogue created.",
                                type: "success",
                            });
                            const createdId =
                                res?.data?.metadata?.catalogueId ||
                                res?.data?.catalogue?._id ||
                                res?.data?.catalogue?.id;
                            if (createdId) {
                                trackCatalogueCreated(String(createdId));
                            }
                            props.closeModal();
                            props.getAllData();
                        } else {
                            notifications({
                                title: "Error!",
                                message: "Could not create this catalogue. Your entries are still here; please try again.",
                                type: "danger",
                            });
                        }
                    }
                );
        }
    };
    // handle change
    const handleChange=(e: any) => {
        let name = e.target.name;
        let value = e.target.value;
        setError((previous: any) => ({ ...previous, [name]: "" }));
        setForm({
            ...form,
            [name]:value
        })
    }
    return (
        <>
            <div className="AddCatalogue">
                <div className="form">
                    {loading ? (
                        <div className="LoaderDivModal">
                            <Loader />
                        </div>
                    ) : (
                        <>
                            <div className="formDiv">
                                <Label>
                                    Name<span>*</span>
                                </Label>
                                <Input
                                    name="name"
                                    className="form-control"
                                    placeholder="Type Name"
                                    value={form?.name}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                />
                                {Error.name ? (
                                    <p className="RequiredField">{Error?.name} </p>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="formDiv">
                                <Label>
                                    Description<span>*</span>
                                </Label>
                                <Input
                                    name="description"
                                    className="form-control"
                                    placeholder="Description"
                                    value={form?.description}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                />
                                {Error.description ? (
                                    <p className="RequiredField">{Error?.description} </p>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="formDiv">
                                <Label>
                                    Category
                                </Label>
                                <Input
                                    name="category"
                                    className="form-control"
                                    placeholder="e.g., Textiles, Handicrafts, Fashion"
                                    value={form?.category}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                />
                                {Error.category && (
                                    <p className="RequiredField">{Error?.category} </p>
                                )}
                            </div>
                            <div className="formDiv">
                                <Label>
                                    Target Market
                                </Label>
                                <Input
                                    name="targetMarket"
                                    className="form-control"
                                    placeholder="e.g., Domestic, International, B2B, B2C"
                                    value={form?.targetMarket}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                />
                                {Error.targetMarket && (
                                    <p className="RequiredField">{Error?.targetMarket} </p>
                                )}
                            </div></>

                    )}
                    <Button className="artButton"
                        disabled={loading}
                        onClick={() => handleSubmit()}>
                        {loading ? "Processing" : "Save"}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default connect(null, {
    createCatAlogue,
    updateCatAlogue,
})(AddOrEditCatalogue);
